module.exports = __webpack_public_path__ + "static/media/d1e15a57-05c5-4f37-b170-f1a407a0e53b_1.fdb0a0c95bc88289b64774e89ad86f54 (1).b95108ee.jpeg";